<template>
  <div>
    <v-layout wrap class="mb-3">
      <v-flex xs8>{{ $t('customer says') }}</v-flex>
      <v-flex xs4 class="text-xs-right" v-if="$store.getters.getPackage == 'premium'">
        <intent-prefill-question @onAddPrefill="onAddPrefill"></intent-prefill-question>
      </v-flex>
    </v-layout>
    <label class="caption" style="margin-bottom: 0px">
      <template>{{ $t('Sentence') }}</template>
    </label>
    <v-modal-help size="1em">
      <div slot="body">
        <div style="padding: 15px">
          <p class="strong">ตัวอย่าง:</p>
          <p>
            ตั้งค่าว่า:
            <span class="strong primary-color">"สอบถามค่าบริการสินค้าหน่อยค่ะ"</span>
            หากลูกค้าพิมพ์มาว่า "สอบถามค่าบริกานจ่ะ" กรณีนี้ถึงแม้ว่า ลูกค้าพิมพ์คำว่า
            <span class="strong primary-color">"บริกาน"</span> ผิด และใช้คำว่า
            <span class="strong primary-color">"จ่ะ"</span>
            แทนคำว่า
            <span class="strong primary-color">"ค่ะ"</span>
            เหมือนที่เราตั้งค่าไว้ บอทก็ยังเข้าใจและตอบกลับได้
          </p>
          <p>
            <span class="underline">Note:</span> พิมพ์ประโยคไปได้เยอะๆเพื่อให้บอทตอบได้แม่นยำขึ้น
          </p>
        </div>
      </div>
    </v-modal-help>
    <div class="form-control" :class="{ 'has-error': errorMessage['normal'] != '' }">
      <tags
        style="margin-bottom: 5px"
        v-model="tag"
        :tags="normal"
        @tags-changed="
          newTags => {
            normal = newTags
            updateQuestion()
          }
        "
        @before-adding-tag="checkTag('normal', $event)"
        :btnText="$t('Add')"
      ></tags>
      <input type="hidden" v-model="normal" name="tag_normal" :data-vv-as="$t('question')" />
      <span class="text-error" v-show="errorMessage['normal'] != ''">{{
        errorMessage['normal'] != '' ? $t('Duplicate Question') : ''
      }}</span>
    </div>

    <label class="caption" style="margin-top: 10px">{{ $t('Keyword') }}</label>
    <v-modal-help size="1em">
      <div slot="body">
        <div style="padding: 15px">
          <p class="strong">ตัวอย่างแบบ1:</p>
          <p>
            การเซ็ทแบบคีย์เวิร์ดมีโอกาสผิดพลาดได้ ถ้าเซต<span class="strong primary-color">
              "ค่าบริการ" </span
            >ไว้ บอทจะดึงประโยคที่มีคำว่า<span class="strong primary-color"> ค่าบริการ </span
            >ไปตอบทันที เช่น <span class="strong primary-color">ค่าบริการ</span>เท่าไหร่คะ และ
            <span class="strong primary-color">ค่าบริการ</span>โปรนี้ต่างจากค่าบริการโปรก่อนยังไงคะ
            มันจะตอบเหมือนกันทั้งที่จริงๆแล้ว มันเป็นคนละความหมาย
          </p>
          <div class="hr" style="margin-bottom: 15px"></div>
          <p class="strong">ตัวอย่างแบบ2:</p>
          <p>
            ตั้งค่าว่า:
            <span class="strong primary-color">"สอบถาม&&สินค้า"</span>
            หากลูกค้าพิมพ์ประโยคที่มีคำว่า
            <span class="strong primary-color">สอบถาม</span> และ
            <span class="strong primary-color">สินค้า</span> อยู่ในประโยคเดียวกัน
            บอทจะตอบตามที่ตั้งค่าทันที
          </p>
          <p><span class="underline">Note:</span> สัญลักษณ์ "&&" หมายถึง "และ"</p>
        </div>
      </div>
    </v-modal-help>

    <div class="form-control" :class="{ 'has-error': errorMessage['keyword'] != '' }">
      <tags
        style="margin-bottom: 5px"
        v-model="tag"
        :tags="keyword"
        @tags-changed="
          newTags => {
            keyword = newTags
            updateQuestion()
          }
        "
        @before-adding-tag="checkTag('keyword', $event)"
        :btnText="$t('Add')"
      ></tags>
      <span class="text-error" v-show="errorMessage['keyword'] != ''">{{
        errorMessage['keyword'] != '' ? $t('Duplicate Question') : ''
      }}</span>
    </div>

    <label class="caption" style="margin-top: 10px">{{ $t('Exact word') }}</label>
    <v-modal-help size="1em">
      <div slot="body">
        <div style="padding: 15px">
          <p class="strong">ตัวอย่าง:</p>
          <p>
            ตั้งค่าว่า:
            <span class="strong primary-color">"สนใจ"</span>
            ลูกค้าต้องพิมพ์เหมือนคำที่ตั้งค่าไว้เป๊ะๆ บอทถึงจะสามารถตอบได้
            หากลูกค้าตกคำใดคำนึงหรือสะกดผิด บอทจะไม่สามารถตอบได้
          </p>
          <p>
            ยกตัวอย่าง:<span class="strong primary-color">
              Xสนใจค่ะ&nbsp;&nbsp;Xสนใจครับ&nbsp;&nbsp;/สนใจ</span
            >
          </p>
        </div>
      </div>
    </v-modal-help>

    <div class="form-control" :class="{ 'has-error': errorMessage['exactly'] != '' }">
      <tags
        style="margin-bottom: 5px"
        v-model="tag"
        :tags="exactly"
        @tags-changed="
          newTags => {
            exactly = newTags
            updateQuestion()
          }
        "
        @before-adding-tag="checkTag('exactly', $event)"
        :btnText="$t('Add')"
      ></tags>
      <span class="text-error" v-show="errorMessage['exactly'] != ''">{{
        errorMessage['exactly'] != '' ? $t('Duplicate Question') : ''
      }}</span>
    </div>

    <div class="form-control">
      <label class="caption" style="margin-top: 10px">{{ $t('Image') }}</label>
      <v-layout row wrap>
        <v-flex
          class="ma-1"
          xs2
          v-for="(qimg, qimgindex) in q_img"
          :key="'questionimage__' + qimgindex"
          style="position: relative"
        >
          <div style="position: absolute; right: -14px; top: -15px; z-index: 1">
            <v-btn @click="q_img.splice(qimgindex, 1)" depressed color="primary" small icon
              ><v-icon small>close</v-icon></v-btn
            >
          </div>
          <v-responsive
            :style="
              `border: 1.5px solid var(--primary-color); border-radius: 9px; background-image:url(${qimg});background-size: cover;`
            "
            :aspect-ratio="1 / 1"
          >
          </v-responsive>
        </v-flex>
        <v-flex class="ma-1" xs2 style="cursor: pointer">
          <div class="image_question_container_add">
            <uploadfile v-model="q_img">
              <v-responsive
                :aspect-ratio="1"
                class="text-xs-center"
                style="display: flex; justify-items: center; align-items: center"
              >
                <a href="javascript:void(0);" class="btn-tag" style="margin: 0px"
                  ><i class="fas fa-plus"></i>
                  Add
                </a>
              </v-responsive>
            </uploadfile>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="hr" style="margin-top: 20px"></div>
    <div class="text-xs-center" style="margin: -13px; margin-bottom: 10px">
      <a
        class="text btn-advanced"
        href="javascript:void(0);"
        @click="onShowAdvance"
        style="position: relative"
      >
        <!-- {{$t('Advanced')}} -->
        <i class="fa" :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"></i>
        <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
      </a>
    </div>

    <div style="margin-top: 5px" v-show="showAdvanced">
      <label class="caption" for>{{ $t('Start with') }}</label>
      <template v-if="$store.getters.getPackage == 'premium'">
        <div class="form-control" :class="{ 'has-error': errorMessage['startwith'] != '' }">
          <tags
            style="margin-bottom: 5px"
            v-model="tag"
            :tags="startwith"
            @tags-changed="
              newTags => {
                startwith = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('startwith', $event)"
            :btnText="$t('Add')"
          ></tags>
          <span class="text-error" v-show="errorMessage['startwith'] != ''">{{
            errorMessage['startwith'] != '' ? $t('Duplicate Question') : ''
          }}</span>
        </div>
      </template>
      <div v-else>
        <ul class="tags pl-0" style="margin-bottom: 5px">
          <li
            class="tag"
            v-for="(question, index) in startwith"
            :key="'normal_question_' + index"
            :class="{ disabled: true }"
          >
            <specialtext :text="question.text"></specialtext>
            <i class="mark fas fa-exclamation-circle"></i>
          </li>
          <li style="display: inline-block; text-align: center; position: relative">
            <v-premium-lock :inline="true" />
          </li>
        </ul>
      </div>

      <label class="caption" for style="margin-top: 10px">{{ $t('End with') }}</label>

      <template v-if="$store.getters.getPackage == 'premium'">
        <div class="form-control" :class="{ 'has-error': errorMessage['endwith'] != '' }">
          <tags
            style="margin-bottom: 5px"
            v-model="tag"
            :tags="endwith"
            @tags-changed="
              newTags => {
                endwith = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('endwith', $event)"
            :btnText="$t('Add')"
          ></tags>
          <span class="text-error" v-show="errorMessage['endwith'] != ''">{{
            errorMessage['endwith'] != '' ? $t('Duplicate Question') : ''
          }}</span>
        </div>
      </template>
      <div v-else>
        <ul class="tags pl-0" style="margin-bottom: 5px">
          <li
            class="tag"
            v-for="(question, index) in endwith"
            :key="'normal_question_' + index"
            :class="{ disabled: true }"
          >
            <specialtext :text="question.text"></specialtext>
            <i class="mark fas fa-exclamation-circle"></i>
          </li>
          <li style="display: inline-block; text-align: center; position: relative">
            <v-premium-lock :inline="true" />
          </li>
        </ul>
      </div>

      <label class="caption" for style="margin-top: 10px">{{ $t('Start and End with') }}</label>

      <template v-if="$store.getters.getPackage == 'premium'">
        <div class="form-control" :class="{ 'has-error': errorMessage['startandendwith'] != '' }">
          <tags
            style="margin-bottom: 5px"
            v-model="tag"
            :tags="startandendwith"
            @tags-changed="
              newTags => {
                startandendwith = newTags
                updateQuestion()
              }
            "
            @before-adding-tag="checkTag('startandendwith', $event)"
            :btnText="$t('Add')"
          ></tags>
          <span class="text-error" v-show="errorMessage['startandendwith'] != ''">
            <template v-if="errorMessage['startandendwith'] == 'duplicate'">{{
              $t('Duplicate Question')
            }}</template>
            <template v-else-if="errorMessage['startandendwith'] == 'requiredand'">{{
              $t('Please type && in between a word (Ex.www&&com)')
            }}</template>
          </span>
        </div>
      </template>
      <div v-else class="mb-3">
        <ul class="tags pl-0" style="margin-bottom: 5px">
          <li
            class="tag"
            v-for="(question, index) in startandendwith"
            :key="'normal_question_' + index"
            :class="{ disabled: true }"
          >
            <specialtext :text="question.text"></specialtext>
            <i class="mark fas fa-exclamation-circle"></i>
          </li>
          <li style="display: inline-block; text-align: center; position: relative">
            <v-premium-lock :inline="true" />
          </li>
        </ul>
      </div>
    </div>

    <label v-show="$store.getters.getPackage != 'premium'" class="caption pb-3">
      <i class="fas fa-exclamation-circle"></i>
      {{
        $t(
          'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
        )
      }}
    </label>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import IntentPrefillQuestion from './IntentPrefillQuestion'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/UploadMultipleFileQuestion.vue'
export default {
  props: ['value', 'q_images'],
  data: function() {
    return {
      showAdvanced: false,
      result: '',
      tag: '',
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],

      errorMessage: {
        normal: '',
        keyword: '',
        exactly: '',
        startwith: '',
        endwith: '',
        startandendwith: ''
      },
      testimg: ''
    }
  },
  components: {
    Tags,
    IntentPrefillQuestion,
    specialtext,
    uploadfile
  },
  computed: {
    q_img: {
      get() {
        return this.q_images
      },
      set(val) {
        this.$emit('update:q_images', val)
      }
    }
  },
  mounted: function() {
    this.result = this.value
    this.formatData(this.value)
  },
  methods: {
    onAddPrefill: function(payload) {
      this.normal.push({ text: payload })
    },
    onShowAdvance: function() {
      this.showAdvanced = !this.showAdvanced
      // if (this.$store.getters.getPackage === 'premium') {
      // }
    },
    checkTag(type, obj) {
      this.errorMessage[type] = ''
      if (obj.tag.isDuplicate) {
        this.errorMessage[type] = 'duplicate'
        obj.error()
      } else if (type === 'startandendwith' && obj.tag.text.split('&&').length - 1 !== 1) {
        this.errorMessage[type] = 'requiredand'
        obj.error()
      } else obj.addTag()
    },
    formatData: function(text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function(question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({ text: keyword })
          } else {
            vm.normal.push({ text: question })
          }
        })
      }
    },
    updateQuestion: function() {
      this.result = ''
      var result = []
      var normal = []
      this.normal.map(function(key, index) {
        normal.push(key.text)
      })
      if (normal && normal.length > 0) {
        result.push(normal.join(','))
      }

      var keyword = []
      this.keyword.map(function(key, index) {
        keyword.push('includes(' + key.text + ')')
      })
      if (keyword && keyword.length > 0) {
        result.push(keyword.join(','))
      }

      var exactly = []
      this.exactly.map(function(key, index) {
        exactly.push('exacts(' + key.text + ')')
      })
      if (exactly && exactly.length > 0) {
        result.push(exactly.join(','))
      }

      var startwith = []
      this.startwith.map(function(key, index) {
        startwith.push('startswith(' + key.text + ')')
      })
      if (startwith && startwith.length > 0) {
        result.push(startwith.join(','))
      }

      var endwith = []
      this.endwith.map(function(key, index) {
        endwith.push('endswith(' + key.text + ')')
      })
      if (endwith && endwith.length > 0) {
        result.push(endwith.join(','))
      }

      var startandendwith = []
      this.startandendwith.map(function(key, index) {
        startandendwith.push('startsendswith(' + key.text + ')')
      })
      if (startandendwith && startandendwith.length > 0) {
        result.push(startandendwith.join(','))
      }

      //   this.result = result.join(',')
      this.$emit('input', result.join(','))
    }
  },
  watch: {
    value: function() {
      this.result = this.value
      this.formatData(this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.image_question_container {
  display: flex;
  overflow: hidden;
  justify-items: center;
  align-items: center;
  border: 1.5px solid var(--primary-color);
  border-radius: 9px;
}
.image_question_container_add {
  display: flex;
  overflow: hidden;
  justify-items: center;
  align-items: center;
  height: 100%;
  border: 2px dotted var(--primary-color);
  border-radius: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentQuestion.vue